<template>
  <div class="bg_color">
    <top-header :type="15" :placeholder="'我要买二手房'" :hasBorder="true" :bgColor="'#fff'" fontSize="0.32rem"
      @goBack="goback" />
    <div class="top_banner">
      <img src="@/assets/img/hire/banner_xf.png" alt="">
      <div class="main">

        <van-form @submit="onSubmit" validate-trigger="onSubmit">
          <h3>信息录入<van-icon name="question" color="#BEBEBE" /></h3>
          <van-field required v-model="formData.name" name="姓名" label="姓名" placeholder="请输入" />
          <van-field required v-model="formData.fromPhone" name="联系方式" label="联系方式" placeholder="请输入" />
          <van-field name="买房需求" v-model="formData.remark" label="买房需求" placeholder="输入您的买房需求" />
        </van-form>
      </div>

      <div class="main_">
        <h3>出租发布流程</h3>
        <div class="m_flex_box flex_hc flex_vc">
          <div class="flex_v flex_hc flex_vc m_flex w_max">
            <img src="@/assets/img/hire/icon_xstj.png" alt="">
            <p>线上提交</p>
          </div>
          <div class="flex_v flex_hc flex_vc w_min">
            <van-icon name="arrow" />
          </div>
          <div class="flex_v flex_hc flex_vc m_flex w_max w_t">
            <img src="@/assets/img/hire/icon_fpjjr_zh.png" alt="">
            <p>分配经纪人</p>
          </div>
          <div class="flex_v flex_hc flex_vc w_min">
            <van-icon name="arrow" />
          </div>
          <div class="flex_v flex_hc flex_vc m_flex w_max w_t">
            <img src="@/assets/img/hire/icon_dk.png" alt="">
            <p>带看找房</p>
          </div>
          <div class="flex_v flex_hc flex_vc w_min">
            <van-icon name="arrow" />
          </div>
          <div class="flex_v flex_hc flex_vc m_flex w_max w_t">
            <img src="@/assets/img/hire/icon_qy_zh.png" alt="">
            <p>签约过户</p>
          </div>
        </div>
      </div>

      <div class="main_">
        <h3>徐房严选服务优势</h3>
        <div class="m_flex_box flex_vw flex_jz">
          <div class="inner flex_v inner_1">
            <h4>价格优势</h4>
            <p>拒绝双向居间服务费<br />限时优惠服务费仅收1%%</p>
          </div>
          <div class="inner flex_v  inner_2">
            <h4>国企保障</h4>
            <p>国企服务有保障<br />买房全流程服务</p>
          </div>
          <div class="inner flex_v  inner_3">
            <h4>极速响应</h4>
            <p>快速分配服务人员<br />60分钟电话核实</p>
          </div>
          <div class="inner flex_v  inner_4">
            <h4>隐私保护</h4>
            <p>平台隐私信息保护<br />国企平台安全放心</p>
          </div>
          <div class="inner flex_v inner_5">
            <h4>更多福利</h4>
            <p>提供家财险等多项福利<br />购房享装修免费量房...</p>
          </div>
          <div class="inner flex_v  inner_6">
            <h4>法律、贷款保障</h4>
            <p>提供免费购房法律咨询<br />享银行机构贷款专属通道</p>
          </div>
        </div>
      </div>

      <div class="main_">
        <h3>价格公示</h3>
        <div class="serve">
          <p>二手房居间服务费</p>
          <div>
            限时优惠,总购房款1%，无额外费用
          </div>
        </div>
      </div>

      <div class="word">
        选择“提交”，我们会为您提供及时的消息推送服务,并将收集 您的姓名及手机号码用作后续专属服务，届时将有专属客服 人员与您联系，提供优质而专业的房产资讯服务。
      </div>

      <div style="padding-top:2.4rem"></div>
      <div class="footer m_flex_box flex_vc">
        <div class="flex_v m_flex flex_vc" @click="zxzx">
          <img src="@/assets/img/icon_zxzx.png" alt="">
          <p>在线咨询</p>
        </div>
        <div class="flex_v m_flex flex_vc" @click="dhzx">
          <img src="@/assets/img/icon_dhzx.png" alt="">
          <p>电话咨询</p>
        </div>
        <div class="btn" @click="onSubmit">
          <p>提交</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import topHeader from '@/components/header'
import { Swiper, SwiperSlide } from 'vue-awesome-swiper'
import 'swiper/swiper-bundle.css'
import qs from "qs";
export default {
  data() {
    return {
      isApp: this.$route.query.isApp || false,
      textColor: '#fff',
      bgColor: 'transparent',
      formData: {
        houseType: "N",
        fromPhone: "",
        name: "",
        remark:""
      }

    };
  },
  components: {
    topHeader,
  },
  mounted() {
  },
  methods: {
    goback() {
      if ((this.isApp && this.isApp != "false") || this.isApp == "true") {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          window.android.goback(); // 调用原生app的函数
        }
        if (isIOS) {
          window.webkit.messageHandlers.goback.postMessage(null);
        }
        // window.webkit.messageHandlers.goback.postMessage(null);
      } else {
        this.$router.go(-1);
      }
    },
    zxzx() {
      window.location.href = 'https://work.weixin.qq.com/kfid/kfcc7e91a12e3b4f650'
    },
    dhzx() {
      if ((this.isApp && this.isApp != "false") || this.isApp == "true") {
        let u = navigator.userAgent;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
        let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        if (isAndroid) {
          window.android.makeCall(); // 调用原生app的函数
        }
        if (isIOS) {
          window.webkit.messageHandlers.makeCall.postMessage(null);
        }
        // window.webkit.messageHandlers.goback.postMessage(null);
      } else {
        window.location.href = "tel:4006212666,1";
      }
    },
    onSubmit() {
      if (this.formData.name == "") {
        this.$toast("请输入姓名")
        return
      } else if (this.formData.fromPhone == "") {
        this.$toast("请输入联系方式")
        return
      } else if (!(/^1[3456789]\d{9}$/.test(this.formData.fromPhone))) {
        this.$toast("请输入正确的联系方式")
        return
      }
      this.$request.post('erpService/yw/api/onlineUser/saveHouseUser', qs.stringify(this.formData)).then(res => {
        if (res.success) {
          this.$toast(res.message)
          setTimeout(() => {
            if ((this.isApp && this.isApp != "false") || this.isApp == "true") {
              let u = navigator.userAgent;
              let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //g
              let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
              if (isAndroid) {
                window.android.goback(); // 调用原生app的函数
              }
              if (isIOS) {
                window.webkit.messageHandlers.goback.postMessage(null);
              }
              // window.webkit.messageHandlers.goback.postMessage(null);
            } else {
              this.$router.go(-1);
            }
          }, 500)
        } else {
          this.$toast(res.message)
        }
      })

    }
  },
};
</script>
<style lang="less" scoped>
.footer {
  background: #fff;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 0 0.3rem;
  height: 1.3rem;

  .btn {
    width: 50%;

    p {
      text-align: center;
      color: #FFFFFF;
      background: #3076F5;
      padding: 0.3rem 0;
      border-radius: 5px;
    }
  }

  .m_flex {
    img {
      width: 0.44rem;
      height: 0.44rem;
    }
  }

}

.bg_color {
  background-color: #f6f6f6;
}

.top_banner {
  position: relative;
  clear: both;

  img {
    width: 100%;
  }
}

.word {
  width: 7.04rem;
  margin: 0 auto;
  color: #666666;
  font-size: 0.26rem;
  line-height: 0.4rem;
  margin-top: 0.3rem;
  padding: 0 0.1rem; 
  box-sizing: border-box;
}

.main {
  width: 7.04rem;
  border-radius: 10px;
  position: relative;
  z-index: 2;
  // position: absolute;
  // top: 2rem;
  // left: 50%;
  // transform: translateX(-50%);
  margin: -20px auto 0;
  background: #FFFFFF;

  h3 {
    padding: 0.2rem 0.3rem 0;
    font-size: 0.32rem;
    font-weight: 900;
  }

}

.main_ {
  width: 7.04rem;
  border-radius: 10px;
  background: #FFFFFF;
  margin: 0 auto;
  padding: 0.3rem;
  box-sizing: border-box;
  margin-top: 0.2rem;

  .serve {
    padding: 0.45rem 0.35rem;
    margin: 0.1rem;
    background-size: 100% 100%;
    background-image: url("../../assets/img/hire/bg_bd.png");

    p {
      padding: 0.1rem 0 0.4rem 0;
      font-size: 0.32rem;
      font-weight: 700;
    }

    div {
      padding: 0.2rem 0 0.2rem 0.2rem;
      background: #EBF1FE;
      color: #3076F5;
      border-radius: 5px;
      position: relative;
      font-size: 0.28rem;

      &::before {
        background-color: #3076F5;
        display: block;
        content: "";
        height: 0.3rem;
        position: absolute;
        top: 50%;
        left: 0;
        width: 4px;
        transform: translateY(-50%);
      }
    }
  }

  .inner {
    width: 49%;
    font-size: 0.26rem;
    color: #999999;
    padding: 0.2rem 0.6rem 0.2rem 0.2rem;
    box-sizing: border-box;

    img {
      width: 1rem;
      height: 1rem;
    }

    h4 {
      font-size: 0.3rem;
      color: #000;
      font-weight: 700;
      padding: 0.2rem 0 0.1rem 0;
    }

    p {
      text-align: left;
    }
  }

  .inner_1 {
    padding: 0.2rem 0.4rem 0.2rem 0.2rem;
    background-size: 100% 100%;
    background-image: url("../../assets/img/hire/bg_gqbz.png");

    h4 {
      color: #335CAC;
    }

    color:#3D5F9E;
  }

  .inner_2 {
    background-size: 100% 100%;
    background-image: url("../../assets/img/hire/bg_jsxy.png");

    h4 {
      color: #7A3D10;
    }

    color:#814721;
  }

  .inner_3 {
    margin-top: 0.2rem;
    background-size: 100% 100%;
    background-image: url("../../assets/img/hire/bg_ysbh.png");

    h4 {
      color: #7A3D10;
    }

    color:#814721;
  }

  .inner_4 {
    margin-top: 0.2rem;
    background-size: 100% 100%;
    background-image: url("../../assets/img/hire/bg_hlmj.png");

    h4 {
      color: #335CAC;
    }

    color:#3D5F9E;
  }

  .inner_5 {
    padding: 0.2rem 0 0.2rem 0.2rem;
    margin-top: 0.2rem;
    background-size: 100% 100%;
    background-image: url("../../assets/img/hire/bg_gqbz.png");

    h4 {
      color: #335CAC;
    }

    color:#3D5F9E;
  }

  .inner_6 {
    padding: 0.2rem 0 0.2rem 0.2rem;
    margin-top: 0.2rem;
    background-size: 100% 100%;
    background-image: url("../../assets/img/hire/bg_jsxy.png");

    h4 {
      color: #7A3D10;
    }

    color:#814721;
  }

  h3 {
    padding: 0.1rem 0 0.3rem 0;
    font-size: 0.32rem;
    font-weight: 900;
  }

  img {
    height: 0.5rem;
    width: 0.5rem;
  }

  .w_min {
    width: 4%;
  }

  .w_max {
    p {
      font-size: 0.26rem;
      // font-weight: 900;
    }
  }

  .w_t {
    p {
      color: #666666
    }
  }
}
</style>